<template>
  <div style="background: #3d4553;;width: 100%;height: 180px" v-if="!info && ipt != 'WXLogin'&& ipt != 'examination' && ipt != 'questions_echo'&& ipt != 'examination2'">
    <div style="
        width: 1200px;
        height: 180px;
        margin: 0 auto;
        background: #3d4553;
      ">
      <div style="float: left;width: 200px;">
        <img style="height: 60px;margin-top:60px;" src="../../../static/images/logo(4).png" alt="" />
      </div>
      <div
        style="display: inline-block;margin:35px 180px;font-size: 15px;font-weight: 400;color: #BBBBBB;line-height:20px;width: 460px;">
        <p class="pel3" style="margin-bottom:20px">Copyright 2022 - 2027 www.yfjyw.com.cn All Rights Reserved. <div @click="Jump_fun()" v-if="isUserAgent == -1" style="height: 20px;float: right;cursor: pointer;opacity: 0; margin-right: 110px;">管理端</div></p>
        <p class="pel1" style="margin-bottom:20px;">医方教育科技发展(济南)有限公司 版权所有</p>
        <p class="pel2" style="cursor: pointer;"><span @click="quety" class="span1">鲁ICP备2022014093号-1</span> <span @click="quety1" class="span2"><img style="vertical-align: sub;margin:0 5px 0 10px;" src="../../../static/images/xiaotubiao/备案图标.png">鲁公网安备 37010102001707号</span></p>
        <!-- 鲁公网安备：37010202001539 -->
      </div>
      <!-- 7月27日，需要将其隐藏，复制桥联和泽众的时候使用 -->
      <div
        style="float: right;margin:40px 0px 40px;font-weight: bold;color: #fff;vertical-align: top;font-size: 16px;width: 180px;">
        <img src="../../../static/images/dianhua.png" alt=""
          style="width: 40px; margin-right: 5px;float: left;margin-bottom: 20px;" />
        <div style="float: right;margin-bottom:4.4px;">
          客 服 热 线
          <p>13165127159</p>
        </div>
        <!-- <div style="font-weight:400">
          <p style="float: left;">在线客服</p>
          <p style="float: right;">意见反馈</p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import "../../../static/css/style.css";

export default {
  data() {
    return {
      versionNumber: "", //版本号
      code: "versionNumber",
      pageInformationIsshow: false,
      ipt: "",
      info: false,
      isUserAgent: 0
    };
  },
  watch: {
    $route(to, from) {
      this.ipt = to.name;
      if (this.ipt == 'video_detail' || this.ipt == 'detai') {
        this.info = true
      } else {
        this.info = false
      }
    },
  },
  created() {
    this.isUserAgent = this.$config.baseUrl.isUserAgent;
  },
  methods: {
    Jump_fun() {
      let value = "http://" + window.location.host + "/system";
      window.open(value,"_blank")
    },
    //获取版本号
    getversionNumber() {
      var that = this;
      var posturl =
        this.config.baseUrl.pro +
        "/Base_Config/apiGetPagedBase_Configs?page=1&limit=1&KeyWord=" +
        this.code;
      axios
        .request({
          url: posturl,
          methods: "get",
          changeOrigin: true
        })
        .then((resp) => {
          if (
            resp.data.result.data != null &&
            resp.data.result.data != undefined &&
            resp.data.result.data != ""
          ) {
            this.pageInformationIsshow = true;
            that.versionNumber = "版本号：" + resp.data.result.data[0].value;
            //this.versionNumber = resp.data.result.data[0].remark;
            //this.formData.id = resp.data.result.data[0].id;
          } else {
            this.pageInformationIsshow = false;
          };
        })
        .catch((err) => {
          this.$Message.error("数据加载失败：" + err);
        });
    },
    getdata() {
      // console.log("数据加载");
    },
    linkclick(url) {
      window.location.href = url;
    },
    quety(){
      window.open('https://beian.miit.gov.cn/', '_blank');
    },
    quety1(){
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37010102001707', '_blank');
    }
  },
  mounted() {
    // this.getversionNumber();
    // this.getdata();
  }
};
</script>
<style scoped>

.pel1:hover {
  color: #fff !important;
}

/* .pel2:hover {
  color: #fff !important;
} */
.span1:hover {
  color: #fff !important;
}
.span2:hover {
  color: #fff !important;
}
.pel4:hover {
  color: #fff !important;
}

.pel3:hover {
  color: #fff !important;
}

.link {
  height: 50;
  width: 100;
}

.right {
  width: 4.0896rem;
  height: 0.8125rem;
  opacity: 1;
  margin-left: 3.7917rem;
  position: absolute;
  top: 0.2167rem;
}

.right1 {
  width: 0.6042rem;
  height: 0.7448rem;
  opacity: 1;
  display: block;
  float: left;
  text-align: center;
}

.right1 img {
  width: 0.4688rem;
  height: 0.4688rem;
  background: #FFFFFF;
  opacity: 1;
  border-radius: 0px;
  margin: 0 .0417rem;
}

.right1 .title {
  display: block;
  font-size: 0.0729rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: .1042rem;
  color: #FFFFFF;
  margin-top: 0.0313rem;
  color: #DDDDDD;
}

.right2 {
  width: .7875rem;
  height: .8125rem;
  opacity: 1;
  display: block;
  float: left;
  margin-left: .1667rem;
}

.right2 img {
  width: .5625rem;
  height: .5625rem;
  background: #FFFFFF;
  opacity: 1;
  border-radius: 0px;
  margin-left: .1042rem;
}

.right2 .title {
  display: block;
  width: .7625rem;
  height: .1354rem;
  font-size: .1042rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: .1042rem;
  color: #FFFFFF;
  /* margin-left: .1042rem; */
  opacity: 1;
  text-align: center;
  margin-top: .0521rem;
}

.right3 {

  float: left;
  width: .7875rem;
  height: .8125rem;
  opacity: 1;
  margin-left: .1667rem;
}

.right3 img {
  width: .5625rem;
  height: .5625rem;
  background: #FFFFFF;
  opacity: 1;
  margin-left: .1042rem;
  border-radius: 0px;
}

.right3 .title {
  display: block;
  width: 0.7917rem;
  height: .1354rem;
  font-size: .1042rem;
  font-family: Microsoft YaHei;
  margin-left: .1042rem;
  font-weight: 400;
  line-height: .1042rem;
  color: #FFFFFF;
  margin-top: .0521rem;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/webBottom/webBottom.vue